import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary
} from "material-ui/ExpansionPanel";
import Typography from "material-ui/Typography";
import ExpandMoreIcon from "material-ui-icons/ExpandMore";
import List, { ListItem, ListItemIcon, ListItemText } from "material-ui/List";
import RestaurantMenu from "material-ui-icons/RestaurantMenu";
import LocalBar from "material-ui-icons/LocalBar";

import { DateTime } from "luxon";
import moment from "moment";

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },

  info: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    margin: 20
  }
});

class MenuItem extends React.Component {
  state = {
    expanded: null
  };

  handleChange = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  };

  render() {
    const { classes } = this.props;
    const { menuName, items, menuTimes, info } = this.props.menu;

    const timeRange =
      moment(
        DateTime.fromObject({
          hour: menuTimes[0].startTime[0],
          minute: menuTimes[0].startTime[1]
        }).toISO()
      ).format("LT") +
      " - " +
      moment(
        DateTime.fromObject({
          hour: menuTimes[0].endTime[0],
          minute: menuTimes[0].endTime[1]
        }).toISO()
      ).format("LT");

    return (
      <div className={classes.root}>
        <ExpansionPanel
          expanded={this.state.expanded}
          onChange={this.handleChange}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>{menuName}</Typography>
            <Typography className={classes.secondaryHeading}>
              &nbsp;&nbsp;{timeRange}
            </Typography>
          </ExpansionPanelSummary>
          {info ? (
            <Typography className={classes.info}>{info}</Typography>
          ) : (
            <span />
          )}
          <ExpansionPanelDetails>
            <List>
              {items.map(item => {
                return (
                  <div className={classes.root} key={item.id}>
                    <ListItem>
                      <ListItemIcon>
                        {item.itemType === "Drink" ? (
                          <LocalBar />
                        ) : (
                          <RestaurantMenu />
                        )}
                      </ListItemIcon>

                      <ListItemText primary={item.itemName} />

                      <ListItemText
                        style={{
                          textAlign: "right"
                        }}
                        primary={
                          item.itemDiscount
                            ? item.itemDiscount
                            : item.happyPrice
                        }
                      />
                    </ListItem>
                  </div>
                );
              })}
            </List>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <br />
      </div>
    );
  }
}

MenuItem.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MenuItem);



// WEBPACK FOOTER //
// ./src/Features/City/MenuItem.js